'use client';

import { useSessionStorage } from 'react-use';
import { useEffect } from 'react';

import type { DatoBlock, DatoImage, DatoModuleFormat } from '@/lib/datocms';
import { Storytelling } from '@/app/components/client/storytelling';

import type { CampusParamsParsed } from '../../page';
import type { FlexProps } from '@ironhack/design-system2';
import type { ReactElement } from 'react';

export type Header = DatoBlock<{
  description: string;
  title: string;
  image: DatoImage;
}>;

type Props = { data: Header; params: CampusParamsParsed } & FlexProps;

export const Header = (props: Props): ReactElement => {
  const { data, params, ...flexProps } = props;
  const { image, description, title } = data;
  const { campus } = params;
  const [storedCampus, setStoredCampus] = useSessionStorage('campus', campus);

  useEffect(() => {
    if (storedCampus !== campus) {
      setStoredCampus(campus);
    }
  }, [storedCampus, campus, setStoredCampus]);

  const storytellingData = {
    columns: [{ subtitle: description, title }, { image }],
    headingProps: { as: 'h1' as const, textStyle: ['5xl', null, '7xl'] },
    moduleFormat: [
      {
        background: 'transparent',
        spacingBottom: ['64', null, '80'],
        spacingTop: ['64', null, '80'],
      },
    ] as [DatoModuleFormat],
  };

  return <Storytelling as="header" data={storytellingData} {...flexProps} />;
};
